import React from "react"
import { adminFacilityDepartmentShape } from "utils/propTypeShapes"
import RemoveMemberDropzone from "./RemoveMemberDropzone"
import DepartmentSegmentList from "./DepartmentSegmentList"

const DepartmentMembers = ({ department }) => {
  const { id: departmentId, segments } = department

  return (
    <div className="w-full">
      <span className="text-xs">Members</span>
      <div className="w-full flex items-start gap-2">
        <DepartmentSegmentList className="grow" departmentId={departmentId} segments={segments} />
        <RemoveMemberDropzone department={department} />
      </div>
    </div>

  )
}

DepartmentMembers.propTypes = {
  department: adminFacilityDepartmentShape.isRequired,
}

export default DepartmentMembers
